import { connect } from 'react-redux';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { useIntl } from 'react-intl';
import { getWSSContractFields } from '~/reducers/workflow';
import PageLayout from '~/ui/components/PageLayout/PageLayout';

import EmptySectionItem from './EmptySectionItem';
import FieldSectionItem from './FieldSectionItem';

function WssFieldSection({
  // connected
  fields,
}) {
  const intl = useIntl();

  return (
    <PageLayout.SidebarSection
      title={intl.formatMessage({
        id: 'WssFieldSection.strategicSourcingTitle',
        defaultMessage: 'Sourcing Information',
        description: 'Title for the strategic sourcing fields section',
      })}
    >
      <Layout pl={8} pb={4}>
        <Text color="text.secondary">
          {intl.formatMessage({
            id: 'WssFieldSection.fieldsDescription',
            defaultMessage:
              'These fields will appear in the contract request form and cannot be modified.',
            description:
              'Description explaining that WSS fields cannot be modified',
          })}
        </Text>
      </Layout>

      {fields.length === 0 ? (
        <EmptySectionItem />
      ) : (
        fields.map((field) => (
          <FieldSectionItem
            isWssDesignated
            key={field.id}
            field={field}
            isAssigned
          />
        ))
      )}
    </PageLayout.SidebarSection>
  );
}

function mapStateToProps({ workflow }) {
  return {
    fields: getWSSContractFields(workflow),
  };
}

export default connect(mapStateToProps)(WssFieldSection);
